var React = require('react');

function ClockInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M.955 11.5c0-5.269 4.303-9.545 9.618-9.545 1.21 0 2.365.22 3.43.624a1 1 0 10.39-.873A10.614 10.614 0 0010.572 1C4.737 1 0 5.698 0 11.5S4.737 22 10.573 22c5.361 0 9.795-3.963 10.482-9.106a1.5 1.5 0 10-.972.047c-.7 4.586-4.688 8.104-9.51 8.104-5.315 0-9.618-4.277-9.618-9.545zM20.5 11a.5.5 0 100 1 .5.5 0 000-1zm-10.282 3.2L17 7.2l-.683-.7-6.219 6.4-4.556-3.524L5 10.2l5.218 4z","key":0}),React.createElement("path",{"fill":"currentColor","d":"M10 5V3.5h1V5h-1zM10 19.5V18h1v1.5h-1zM17 11h1.5v1H17v-1zM2.5 11H4v1H2.5v-1z","key":1})]);
}

ClockInline.defaultProps = {"viewBox":"0 0 22 22"};

module.exports = ClockInline;

ClockInline.default = ClockInline;
